<template>
  <v-app>
    <page-header />
    <v-main>
      <router-view />
    </v-main>
    <page-footer />
  </v-app>
</template>

<script>
import PageHeader from '@/components/navigation/NavBar'
import PageFooter from '@/components/navigation/BottomNav'

export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter,
  },
  data() {
    return {
      drawer: null,
      items: [
        { title: 'Home', icon: 'mdi-monitor-dashboard', to: '/' },
        { title: 'About', icon: 'mdi-forum', to: '/about' },
        { title: 'Users', icon: 'mdi-account-group', to: '/users' },
        { title: 'Employee', icon: 'mdi-account-group', to: '/emp' },
        { title: 'Products', icon: 'mdi-shopping-search', to: '/prods' },
        { title: 'List', icon: 'mdi-format-list-bulleted', to: '/list' },
        {
          title: 'Waterfall',
          icon: 'mdi-view-dashboard-variant',
          to: '/waterfall',
        },
        { title: 'Calendar', icon: 'mdi-calendar-month', to: '/calendar' },
      ],
    }
  },
}
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

.item img {
  border-radius: 5px;
  width: 100%;
  display: block;
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

/* Blue ribbon */
.ribbon {
  width: 100px;
  height: 100px;
  z-index: 1;
  overflow: hidden;
  position: absolute;
}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 2.5px solid #2980b9;
}

.ribbon span {
  position: absolute;
  display: block;
  width: 150px;
  padding: 10px 0;
  background-color: #3498db;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font: 700 12px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

/* Red ribbon */
.ribbon-red {
  width: 100px;
  height: 100px;
  z-index: 1;
  overflow: hidden;
  position: absolute;
}

.ribbon-red::before,
.ribbon-red::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 2.5px solid #ff7878;
}

.ribbon-red span {
  position: absolute;
  display: block;
  width: 150px;
  padding: 10px 0;
  background-color: red;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font: 700 12px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

/* top left*/
.ribbon-top-left {
  top: -10px;
  left: -10px;
}

.ribbon-top-left::before,
.ribbon-top-left::after {
  border-top-color: transparent;
  border-left-color: transparent;
}

.ribbon-top-left::before {
  top: 0;
  right: 0;
}

.ribbon-top-left::after {
  bottom: 0;
  left: 0;
}

.ribbon-top-left span {
  right: -25px;
  top: 30px;
  transform: rotate(-45deg);
}

/* top right*/
.ribbon-top-right {
  top: -5px;
  right: -5px;
}

.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}

.ribbon-top-right::before {
  top: 0;
  left: 0;
}

.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}

.ribbon-top-right span {
  left: -10px;
  top: 25px;
  transform: rotate(45deg);
}

/* bottom left*/
.ribbon-bottom-left {
  bottom: -10px;
  left: -10px;
}

.ribbon-bottom-left::before,
.ribbon-bottom-left::after {
  border-bottom-color: transparent;
  border-left-color: transparent;
}

.ribbon-bottom-left::before {
  bottom: 0;
  right: 0;
}

.ribbon-bottom-left::after {
  top: 0;
  left: 0;
}

.ribbon-bottom-left span {
  right: -25px;
  bottom: 30px;
  transform: rotate(225deg);
}

/* bottom right*/
.ribbon-bottom-right {
  bottom: -5px;
  right: -5px;
}

.ribbon-bottom-right::before,
.ribbon-bottom-right::after {
  border-bottom-color: transparent;
  border-right-color: transparent;
}

.ribbon-bottom-right::before {
  bottom: 0;
  left: 0;
}

.ribbon-bottom-right::after {
  top: 0;
  right: 0;
}

.ribbon-bottom-right span {
  left: -10px;
  bottom: 25px;
  transform: rotate(-45deg);
}
</style>
